"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmReservationAction = void 0;
var ConfirmReservationAction;
(function (ConfirmReservationAction) {
    ConfirmReservationAction["accept"] = "accept";
    ConfirmReservationAction["reject"] = "reject";
})(ConfirmReservationAction || (exports.ConfirmReservationAction = ConfirmReservationAction = {}));
//# sourceMappingURL=ConfirmReservationAction.js.map